import React from "react";
import ReactDOM from "react-dom/client";
import { EventType, PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./config/authConfig";

import App from "./App";
import { ThemeProvider } from "@mui/material";

import { DefaultTheme } from "./styles/theme";

const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

window.parseBoolean = (value: string | number | undefined): boolean => {
	if (value === undefined || value === null) return false;
	if (typeof value === "number") return value !== 0;
	if (typeof value === "string") return value.toLowerCase().trim() === "true";
	return false;
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
	// <React.StrictMode>
		<ThemeProvider theme={DefaultTheme}>
			<MsalProvider instance={msalInstance}>
				<App />
			</MsalProvider>
		</ThemeProvider>
	// </React.StrictMode>
);